<template>
  <AppCard
    orientation="horizontal"
    :title="$t('hub_apps_step_title_games')"
    :description="$t('hub_apps_step_lead_games')"
    :graphicBgColor="graphicBgColor"
    :is-game-card="true"
  >
    <template v-slot:graphic>
      <img src="../assets/logo/Games.webp" >
    </template>

    <template v-slot:actions>
      <template v-if="isSubscribed">
        <a
          :href="appStoreList.apple"
          class="hub__btn hub__btn--icon-only btn--animated"
        >
          <AppleIcon />
        </a>

        <a
          :href="appStoreList.google"
          class="hub__btn hub__btn--icon-only btn--animated"
        >
          <AndroidIcon />
        </a>
      </template>

      <a v-else href="/subscribe" class="hub__btn hub__btn--subscribe tw-bg-green">
        <span>{{ $t("hub_apps_step_sub_btn") }}</span>
      </a>
    </template>
  </AppCard>
</template>

<script>
import AppCard from "./AppCard.vue";
import AppleIcon from "../graphics/AppleIcon.vue";
import AndroidIcon from "../graphics/AndroidIcon.vue";

export default {
  name: "GamesAppCard",
  components: {
    AppCard,
    AppleIcon,
    AndroidIcon,
  },
  props: {
    isSubscribed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appStoreList: {
        apple: "https://apps.apple.com/us/app/kidjo-games-kids-play-learn/id6445847220",
        google:
          "https://play.google.com/store/apps/details?id=net.kidjo.games.app.playstore",
        amazon:
          "https://www.amazon.com/Kidjo-Kids-Have-Fun-Learn/dp/B06X99VRWG",
        samsung: "samsungapps://ProductDetail/net.kidjo.app.samsung",
      },
      graphicBgColor: {
        from: "gradientLightPurple",
        via: "gradientDarkPurple",
        to: "gradientDarkPurple",
      },
    };
  },
};
</script>
